import React from "react";
import { apiPut } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { isEmpty } from "lodash";
import useToastContext from "hooks/useToastContext";
import { AiFillEye } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";
import helper from "../../utils/helpers";
import { NavLink } from "react-router-dom";

const Table = ({
  users,
  getAllUser,
  handelEdit,
  user,
  page,
  paginationObj,
  sort,
  setSort,
  manager,
}) => {
  const { t } = useTranslation();
  const notification = useToastContext();

  const handelStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.status === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.changeUserStatus}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        getAllUser();
      }
      // }
    } catch (error) {
      console.log("error in get all users list==>>>>", error.message);
    }
  };

  // const handelDelete = async item => {
  //   try {
  //     const path = apiPath.getUsers + '/' + item?._id
  //     const result = await apiDelete(path)
  //     if (result?.status === 200) {
  //       notification.success(result.data.message)
  //       getAllUser({ deletePage: 1 })
  //     }
  //   } catch (error) {
  //     console.log('error in get all users list==>>>>', error.message)
  //   }
  // }

  return (
    <div className="p-3">
      <div
        className="overflow-x-auto relative 
 border"
      >
        <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-6 text-center">
                #
              </th>
              <th
                scope="col"
                className="py-3 px-6 cursor-pointer"
                onClick={() => {
                  if (
                    sort.sort_key === "firstName" &&
                    sort.sort_type === "asc"
                  ) {
                    setSort({
                      sort_key: "firstName",
                      sort_type: "desc",
                    });
                  } else {
                    setSort({
                      sort_key: "firstName",
                      sort_type: "asc",
                    });
                  }
                }}
              >
                <div className="flex ">
                  <span>{t("USERS_FULL_NAME")} </span>
                  <span>
                    {sort.sort_key === "firstName" &&
                      sort.sort_type === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                    {sort.sort_key === "firstName" &&
                      sort.sort_type === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-6 cursor-pointer"
                onClick={() => {
                  if (sort.sort_key === "email" && sort.sort_type === "asc") {
                    setSort({
                      sort_key: "email",
                      sort_type: "desc",
                    });
                  } else {
                    setSort({
                      sort_key: "email",
                      sort_type: "asc",
                    });
                  }
                }}
              >
                <div className="flex justify-left">
                  <span>{t("O_EMAIL_ADDRESS")}</span>
                  <span>
                    {sort.sort_key === "email" && sort.sort_type === "asc" && (
                      <BsArrowUpShort className="w-4 h-4" />
                    )}
                    {sort.sort_key === "email" && sort.sort_type === "desc" && (
                      <BsArrowUpShort className="w-4 h-4 rotate-180" />
                    )}
                  </span>
                </div>
              </th>
              <th scope="col" className="py-3 px-6 text-right">
                <div className="text-right">
                  <span>{t("O_COUNTRY_CODE")}</span>
                </div>
              </th>
              <th scope="col" className="py-3 px-6 text-right">
                <div className="text-right">
                  <span>{t("O_MOBILE")}</span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-6 cursor-pointer"
                onClick={() => {
                  if (
                    sort.sort_key === "createdAt" &&
                    sort.sort_type === "asc"
                  ) {
                    setSort({
                      sort_key: "createdAt",
                      sort_type: "desc",
                    });
                  } else {
                    setSort({
                      sort_key: "createdAt",
                      sort_type: "asc",
                    });
                  }
                }}
              >
                <div className="flex justify-end">
                  <span>{t("O_CREATED_AT")}</span>
                  <span>
                    {sort.sort_key === "createdAt" &&
                      sort.sort_type === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                    {sort.sort_key === "createdAt" &&
                      sort.sort_type === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>
              <th scope="col" className="py-3 px-6 text-right">
                <div className="text-right">
                  <span>{t("O_TOTAL_AUCTION")}</span>
                </div>
              </th>
              {(manager?.add || user?.role === "admin") && (
                <th scope="col" className="py-3 px-6 text-center">
                  {t("O_STATUS")}
                </th>
              )}
              <th scope="col" className="py-3 px-6 text-center">
                {t("O_ACTION")}
              </th>
            </tr>
          </thead>
          <tbody>
            {users &&
              users?.map((item, i) => (
                <tr
                  key={i}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                >
                  <th
                    scope="row"
                    className="py-2 px-2 text-center border-r font-medium text-gray-900  dark:text-white"
                  >
                    {i + 1 + 10 * (paginationObj?.page - 1)}
                  </th>
                  <td className="py-2 px-2 border-r">
                    {`${item?.firstName ?? "-"} ${item?.lastName ?? ""}`}{" "}
                  </td>
                  <td className="py-2 px-2 border-r">{item?.email ?? "-"}</td>
                  <td className="py-2 px-2 border-r text-right">
                    {item?.country_code}
                  </td>
                  <td className="py-2 px-2 border-r text-right">
                    {item?.mobile}
                  </td>
                  <td className="py-2 px-2 border-r text-right">
                    {helper.dateFormat(item?.createdAt)}
                  </td>
                  <td className="py-2 px-2 border-r text-right">
                    {item?.bidsCount}
                  </td>
                  {(manager?.add || user?.role === "admin") && (
                    <td className="py-2 px-2 border-r text-center">
                      <label
                        className="inline-flex relative items-center cursor-pointer"
                        title={`${
                          item?.status === "active" ? "Active" : "Inactive"
                        }`}
                      >
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={item?.status === "active"}
                          onChange={(e) =>
                            helper.alertFunction(
                              `Are you sure want to ${
                                e.target.checked ? "active" : "inactive"
                              } ${item.firstName} ${item?.lastName}?`,
                              item,
                              handelStatusChange
                            )
                          }
                        />
                        <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                      </label>
                    </td>
                  )}
                  <td className="py-2 px-2 border-l">
                    <div className="">
                      <ul className="flex justify-center">
                        <>
                          <li className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                            <NavLink
                              title={t("O_VIEW_USER")}
                              to="/users/view"
                              state={{ item }}
                            >
                              {" "}
                              <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />{" "}
                            </NavLink>
                          </li>
                        </>
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(users) && (
              <tr className="bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700">
                <td className="py-2 px-2 border-r" colSpan={8}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
